import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

function HddtTab({ mode }: { mode: FormMode }) {
  return (
    <div className='p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        {/* Electronic Invoice Usage Section */}
        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Sử dụng hd điện tử</Label>
          <FormField
            type='select'
            name='use_einvoice'
            className='w-[150px]'
            options={[
              { value: '1', label: '1. Có' },
              { value: '0', label: '0. Không' }
            ]}
            disabled={mode === 'view'}
          />
        </div>

        {/* Electronic Invoice Phone Section */}
        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Thư nhận HĐĐT</Label>
          <FormField type='text' name='einvoice_email' className='w-[150px]' disabled={mode === 'view'} />
        </div>

        {/* Electronic Invoice Address Section */}
        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Người đại diện</Label>
          <FormField type='text' name='representative' className='w-[150px]' disabled={mode === 'view'} />
        </div>
      </div>
    </div>
  );
}

export default HddtTab;
